/* maris — interactions. ~1.5KB, zero dependencies, reduced-motion aware. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* sticky header hairline — kicks in once the announcement bar has scrolled away */
    var header = document.querySelector('.mxh');
    if (header) {
      var announce = document.querySelector('.mxa');
      var onScroll = function () {
        var threshold = announce ? announce.offsetHeight : 8;
        header.classList.toggle('is-stuck', window.scrollY > threshold);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* mobile drawer */
    var drawer = document.getElementById('mxh-drawer');
    var burger = document.getElementById('mxh-burger');
    if (drawer && burger) {
      var setOpen = function (open) {
        drawer.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      burger.addEventListener('click', function () { setOpen(true); });
      drawer.querySelectorAll('[data-close], a').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setOpen(false);
      });
    }

    /* editions carousel arrows */
    document.querySelectorAll('.mx-eds').forEach(function (sec) {
      var row = sec.querySelector('.mx-eds__row');
      var prev = sec.querySelector('[data-eds-prev]');
      var next = sec.querySelector('[data-eds-next]');
      if (!row || !prev || !next) return;
      function step() {
        var card = row.querySelector('.mx-eds__card');
        return card ? card.getBoundingClientRect().width + 12 : 320;
      }
      function update() {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });

    /* cart — live repricing via the AJAX cart API, form submit as fallback */
    document.querySelectorAll('[data-mxcart]').forEach(function (form) {
      var aud = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
      var FREE_SHIP = 15000;

      function paint(cart) {
        var lines = form.querySelectorAll('[data-line]');
        lines.forEach(function (line, i) {
          var item = cart.items[i];
          if (!item) { line.remove(); return; }
          var total = line.querySelector('[data-line-total]');
          if (total) total.textContent = aud.format(item.final_line_price / 100);
          var input = line.querySelector('[data-line-qty]');
          if (input) input.value = item.quantity;
        });
        var subtotal = form.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = aud.format(cart.total_price / 100);
        var ship = form.querySelector('[data-ship]');
        if (ship) {
          if (cart.total_price >= FREE_SHIP) {
            ship.textContent = '✓ Free shipping — Australia-wide';
            ship.classList.add('is-free');
          } else {
            ship.textContent = aud.format((FREE_SHIP - cart.total_price) / 100) + ' away from free shipping';
            ship.classList.remove('is-free');
          }
        }
        if (cart.item_count === 0) window.location.reload();
      }

      function change(lineEl, quantity) {
        var lineNo = parseInt(lineEl.dataset.line, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: lineNo, quantity: quantity })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (cart) {
            /* removals shift line numbers — reload for a clean re-render */
            if (quantity === 0) { window.location.reload(); return; }
            paint(cart);
          })
          .catch(function () { form.submit(); });
      }

      form.querySelectorAll('[data-line]').forEach(function (line) {
        var input = line.querySelector('[data-line-qty]');
        line.querySelectorAll('[data-qty]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var next = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.qty, 10);
            next = Math.min(9, Math.max(0, next));
            input.value = next;
            change(line, next);
          });
        });
        input.addEventListener('change', function () {
          var v = Math.min(9, Math.max(0, parseInt(input.value, 10) || 0));
          input.value = v;
          change(line, v);
        });
        var remove = line.querySelector('[data-line-remove]');
        if (remove) remove.addEventListener('click', function (e) {
          e.preventDefault();
          change(line, 0);
        });
      });
    });

    /* collection sort — navigate with the chosen sort_by */
    document.querySelectorAll('[data-mxc-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    /* ugc strip — arrows step one tile */
    document.querySelectorAll('[data-ugc]').forEach(function (ugc) {
      var track = ugc.querySelector('[data-ugc-track]');
      if (!track) return;
      function step() {
        var tile = track.querySelector('.mx-ugc__tile');
        return tile ? tile.getBoundingClientRect().width + 12 : 240;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        ugc.querySelectorAll('[data-ugc-nav]').forEach(function (btn) {
          var dir = parseInt(btn.dataset.ugcNav, 10);
          btn.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
        });
      }
      ugc.querySelectorAll('[data-ugc-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: parseInt(btn.dataset.ugcNav, 10) * step(), behavior: reduced ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });

    /* product gallery carousel — arrows advance one slide, dots track scroll */
    document.querySelectorAll('.mxp__gallery').forEach(function (gal) {
      var track = gal.querySelector('[data-gallery-track]');
      var dots = gal.querySelectorAll('[data-gallery-dots] span');
      var prev = gal.querySelector('[data-gallery-nav="-1"]');
      var next = gal.querySelector('[data-gallery-nav="1"]');
      if (!track) return;
      function index() { return Math.round(track.scrollLeft / track.clientWidth); }
      function update() {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= dots.length - 1;
      }
      [prev, next].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          track.scrollBy({ left: parseInt(btn.dataset.galleryNav, 10) * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });

    /* product page quantity stepper */
    document.querySelectorAll('.mxp__qty').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('[data-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10);
          input.value = Math.min(9, Math.max(1, next));
        });
      });
    });

    /* reveals — CSS failsafe guarantees visibility if this never runs */
    var io = null;
    var seen = new WeakSet();
    function scan() {
      var els = document.querySelectorAll('.mx-rv, .mx-stag, .mx-zoom');
      els.forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        if (reduced || !io) { el.classList.add('is-in'); return; }
        io.observe(el);
      });
    }
    if (!reduced && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    }
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', scan);
  });
})();
